import React, { useRef } from 'react';
import './SliderBranch.css';
import AdminCardHelp from '../AdminCardHelp';

function SliderBranch(props) {
   const branchContainerRef = useRef(null);

   // Handle arrow key navigation at container level (horizontal)
   const handleContainerKeyDown = (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
         const container = branchContainerRef.current;
         if (!container) return;

         // Find all focusable buttons (not disabled, not tabIndex="-1")
         const allButtons = Array.from(container.querySelectorAll('button'));
         const focusableButtons = allButtons.filter(btn =>
            !btn.disabled && btn.tabIndex !== -1
         );
         if (focusableButtons.length === 0) return;

         const currentIndex = focusableButtons.findIndex(btn => btn === document.activeElement);

         if (currentIndex === -1) {
            // No button is focused, focus the first one
            if (focusableButtons.length > 0) {
               focusableButtons[0].focus();
            }
            return;
         }

         let nextIndex;
         if (e.key === 'ArrowLeft') {
            nextIndex = currentIndex > 0 ? currentIndex - 1 : focusableButtons.length - 1;
         } else {
            nextIndex = currentIndex < focusableButtons.length - 1 ? currentIndex + 1 : 0;
         }

         e.preventDefault();
         focusableButtons[nextIndex].focus();
      }
   };

   return (
      <div
         className="SliderBranch"
         ref={branchContainerRef}
         onKeyDown={handleContainerKeyDown}
      >
         {props.entries.map((e) => <SliderBranchEntry   key={e.text} {...e}/>)}
      </div>
   );
}

function SliderBranchEntry(props) {
   const Icon = props.icon;
   const illustration = Icon
      ? <div className="admin-nav-icon-frame" aria-hidden="true">
           <Icon className="admin-nav-icon" strokeWidth={1.5} />
        </div>
      : null;
   const handleKeyDown = (e) => {
      if (!props.disabled && props.onClick && (e.key === 'Enter' || e.key === ' ')) {
         e.preventDefault();
         props.onClick();
      }
      // Arrow keys are handled at container level
   };

   const buttonClass = props.disabled
      ? "SliderBranchChoice Disabled"
      : "SliderBranchChoice";

   return (
      <div className="admin-nav-card">
         <button
            onClick={props.onClick}
            onKeyDown={handleKeyDown}
            disabled={props.disabled}
            className={buttonClass}
            aria-label={props.disabled ? `${props.text} (disabled)` : props.text}
            type="button"
         >
            {illustration}
            <span>{props.text}</span>
         </button>
         {props.description && <AdminCardHelp title={props.text} description={props.description} />}
      </div>
   );
}

export {SliderBranch};
